import { isSharedArrival } from "../url-routing";
import { createPersistedToggle } from "./persisted-toggle";

/** Defaults on when the load arrived on a shared schematic; a stored choice
 *  always wins. */
export const useCableSizeVisibility = createPersistedToggle("twelve-volt:show-cable-size", isSharedArrival);
